import {
  hrSurveyListUrl,
  hrSurveyDetailsUrl,
  surveyFilteringDataUrl,
  surveyScoressUrl,
  surveyScoreDetailsUrl,
  surveyQuestionsUrl,
  surveyQuestionDetailsUrl,
  hrParticipantsUrl,
  hrParticipantDetailsUrl,
  hrQuestionKindUrl,
  myOpenSurveysUrl,
  myClosedSurveysUrl,
  mySurveyFilteringDataUrl,
  mySurveyDetailsUrl,
  hrAnswerDetailsUrl,
  hrAnswerRegistryUrl,
  hrAnswerFilteringUrl,
  answersBySurveyUrl,
  hrSurveyResultDetailsUrl,
  hrSurveySelectListUrl,
  hrSurveyQuestionKindUrl,
  hrQuestionKindSurveyUrl,
} from "../helpers/apiUrls";
import { makeRequest } from "../helpers/makeRequest";
import { prepareUrlWithQueryParams } from "../helpers/methods";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

export default function useHRService() {
  const axiosPrivate = useAxiosPrivate();

  const getSurveysList = (searchParams = undefined) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(hrSurveyListUrl, searchParams)
    );
  };

    const getSurveysSelectList = (searchParams = undefined) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(hrSurveySelectListUrl, searchParams)
    );
  };

  const getSurveyFilteringData = () => {
    return makeRequest(axiosPrivate, surveyFilteringDataUrl);
  };

  const getSurveyDetails = (surveyId) => {
    return makeRequest(axiosPrivate, hrSurveyDetailsUrl(surveyId));
  };

  const  getSurveyResultData = (surveyId) => {
    return makeRequest(axiosPrivate, hrSurveyResultDetailsUrl(surveyId));
  };

  const createSurvey = (data) => {
    return makeRequest(axiosPrivate, hrSurveyListUrl, { method: "POST", data });
  };

  const updateSurvey = (surveyId, data) => {
    return makeRequest(axiosPrivate, hrSurveyDetailsUrl(surveyId), { method: "PATCH", data });
  };

  const getSurveyScores = (surveyId) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(surveyScoressUrl, { survey: surveyId })
    );
  };

  const createSurveyScore = (data) => {
    return makeRequest(axiosPrivate, surveyScoressUrl, { method: "POST", data });
  };

  const updateSurveyScore = (scoreId, data) => {
    return makeRequest(axiosPrivate, surveyScoreDetailsUrl(scoreId), { method: "PATCH", data });
  };

  const deleteSurveyScore = (scoreId) => {
    return makeRequest(axiosPrivate, surveyScoreDetailsUrl(scoreId), { method: "DELETE" });
  };

  const getSurveyQuestions = (surveyId) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(surveyQuestionsUrl, { survey: surveyId })
    );
  };

  const createSurveyQuestion = (data) => {
    return makeRequest(axiosPrivate, surveyQuestionsUrl, { method: "POST", data });
  };

  const updateSurveyQuestion = (questionId, data) => {
    return makeRequest(axiosPrivate, surveyQuestionDetailsUrl(questionId), { method: "PATCH", data });
  };

  const deleteSurveyQuestion = (questionId) => {
    return makeRequest(axiosPrivate, surveyQuestionDetailsUrl(questionId), { method: "DELETE" });
  };

  const getHrParticipants = (searchParams = {}) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(hrParticipantsUrl, searchParams)
    );
  };

  const createHrParticipant = (data) => {
    return makeRequest(axiosPrivate, hrParticipantsUrl, { method: "POST", data });
  };

  const updateHrParticipant = (participantId, data) => {
    return makeRequest(axiosPrivate, hrParticipantDetailsUrl(participantId), { method: "PATCH", data });
  };

  const deleteHrParticipant = (participantId) => {
    return makeRequest(axiosPrivate, hrParticipantDetailsUrl(participantId), { method: "DELETE" });
  };

  const createHrQuestionKind = (data) => {
    return makeRequest(axiosPrivate, hrQuestionKindUrl, { method: "POST", data });
  };

  const getMyOpenSurveys = (searchParams = undefined) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(myOpenSurveysUrl, searchParams)
    );
  };

  const getMyClosedSurveys = (searchParams = undefined) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(myClosedSurveysUrl, searchParams)
    );
  };

  const getMySurveyFilteringData = () => {
    return makeRequest(axiosPrivate, mySurveyFilteringDataUrl);
  };

  const getMySurveyDetails = (surveyId) => {
    return makeRequest(axiosPrivate, mySurveyDetailsUrl(surveyId),);
  };


  const sendMySurvey = (surveyId) => {
    return makeRequest(axiosPrivate, mySurveyDetailsUrl(surveyId), { method: "POST"});
  };

  const updateAnswer = (answerId, data) => {
    return makeRequest(axiosPrivate, hrAnswerDetailsUrl(answerId), { method: "PATCH", data });
  };

  const getAnswerRegistryList = (searchParams = undefined) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(hrAnswerRegistryUrl, searchParams)
    );
  };

  const getAnswerFilteringData = () => {
    return makeRequest(axiosPrivate, hrAnswerFilteringUrl);
  };

  const getAnswersBySurveyList = (surveyId, searchParams = undefined) => {
    return makeRequest(axiosPrivate, prepareUrlWithQueryParams(answersBySurveyUrl(surveyId) ,searchParams));
  };  

  const getSurveyQuestionKindList = (surveyId) => {
    return makeRequest(
      axiosPrivate, hrQuestionKindSurveyUrl(surveyId)
    );
  };

  return {
    getSurveysList,
    getSurveysSelectList,
    getSurveyFilteringData,
    getSurveyResultData,
    getSurveyDetails,
    createSurvey,
    updateSurvey,
    getSurveyScores,
    createSurveyScore,
    updateSurveyScore,
    deleteSurveyScore,
    getSurveyQuestions,
    createSurveyQuestion,
    updateSurveyQuestion,
    deleteSurveyQuestion,
    getHrParticipants,
    createHrParticipant,
    updateHrParticipant,
    deleteHrParticipant,
    createHrQuestionKind,
    getMyOpenSurveys,
    getMyClosedSurveys,
    getMySurveyFilteringData,
    getMySurveyDetails,
    updateAnswer,
    sendMySurvey,
    getAnswerRegistryList,
    getAnswerFilteringData,
    getAnswersBySurveyList,
    getSurveyQuestionKindList
  };
}
